import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/fonts.css'


// Initialize Firebase (imported from config)
import './firebase/config'
import axios from 'axios';

// Set default headers for all axios requests
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.put['Content-Type'] = 'application/json';

// Create the Vue app
const app = createApp(App)

// Mount the app immediately to ensure SPA routing works
app.use(router).mount('#app')
